import { render, staticRenderFns } from "./qrcodeRemind.vue?vue&type=template&id=6c015390&scoped=true"
var script = {}
import style0 from "./qrcodeRemind.vue?vue&type=style&index=0&id=6c015390&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c015390",
  null
  
)

export default component.exports